import React, { Component } from 'react';
import { DatePicker } from 'antd';
import ComponentWrapper from './ComponentWrapper';
import { monthRangeMap } from './componentMappers';

const { RangePicker } = DatePicker;

export default class MonthRangeField extends Component {
  render() {
    return (
      <ComponentWrapper
        {...this.props}
        mapProps={monthRangeMap}
        render={(props) => {
          const { onBlur, onFocus, ...restProps } = props;
          return (
            <RangePicker
              {...restProps}
              onOpenChange={(status) => {
                status ? onFocus?.() : onBlur?.();
              }}
            />
          );
        }}
      />
    );
  }
}
